export enum LocalStorageKeys {
  AUTH = 'auth',
  TEXTBOOK = 'textbook',
}
